export const normalizeData = (data) => {
  return data.map((row) => {
    const ringTime = Number(row['Sum of Ring Time'] || 0);
    const isActuallyAbandoned = Number(row['Missed Conversations']) > 0 && ringTime < 20;

    return {
      ...row,
      RawDate: row.Date,         // preserve original string
      RawTime: row.Time,
      ParsedDate: new Date(`${row.Date} ${row.Time}`), // safe for internal filtering
      Agent: row.Agent,
      Customer: row['Customer Attribute 2']?.split('=')[0]?.trim(),
      Abandoned: isActuallyAbandoned
        ? 1
        : Number(row['Abandoned Conversations'] || 0),
      Missed: isActuallyAbandoned
        ? 0
        : Number(row['Missed Conversations'] || 0),
      Rejected: Number(row['Rejected Conversations'] || 0),
      Handled: Number(row['Handled Conversations'] || 0),
      RingTime: ringTime,
      Segment: row['Segment'],
    };
  });
};
